import { venuesOnEnterSaga } from 'containers/Venues/Venues.onenter.saga';

export default store => ({
  path: '/venues/:hashDescriptor(/:page)',

  indexRoute: {
    onEnter: (nextState, replaceState, cb) =>
      store
        .runSagaOnce(venuesOnEnterSaga, nextState, replaceState)
        .toPromise()
        .then(cb),
  },
});
